import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/search.svg'


const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = {
  key: 0,
  class: "list-title"
}
const _hoisted_3 = {
  key: 1,
  class: "search-bar"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list-item__text" }
const _hoisted_7 = { class: "list-footer" }

import { ref } from "vue";
import Paginator from "@/domains/app/pagination/components/Paginator.vue";
import { ListItemConfig } from "../list";
import { useLoading } from "@/domains/app/loading";


export default /*#__PURE__*/_defineComponent({
  props: {
    searchPlaceholder: null,
    title: null,
    search: null,
    navigation: null,
    items: null,
    loadingKey: null
  },
  emits: ["item:clicked"],
  setup(__props: any, { emit }: { emit: ({
    (e: "item:clicked", item: ListItemConfig): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    searchPlaceholder?: string;
    title?: string;
    search: null | ((payload: string) => Promise<void>);
    navigation:
        | {
              nextPage: () => Promise<void>;
              prevPage: () => Promise<void>;
              toPage: (page: number) => Promise<void>;
              pages: number | null;
          }
        | {
              nextPage: undefined;
              prevPage: undefined;
              toPage: undefined;
              pages: number | null;
          };
    items: ListItemConfig[];
    loadingKey: string;
}





function onItemCliecked(item: ListItemConfig) {
    emit("item:clicked", item);
}

const { loading } = useLoading(props.loadingKey);

const searchPayload = ref("");

return (_ctx: any,_cache: any) => {
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    (__props.search !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            placeholder: __props.searchPlaceholder || 'Rechercher',
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPayload).value = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (__props.search ? __props.search(searchPayload.value) : undefined), ["enter"]))
          }, null, 40, _hoisted_4), [
            [_vModelText, searchPayload.value]
          ]),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "GO",
            class: "search-bar__icon btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.search ? __props.search(searchPayload.value) : undefined))
          })
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "header"),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["list__items", { 'is-loading-items': _unref(loading) }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: item.uid,
          onClick: ($event: any) => (onItemCliecked(item))
        }, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(item.label), 1),
          _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(item)))
        ], 8, _hoisted_5))
      }), 128))
    ], 2)), [
      [_directive_loading_key, __props.loadingKey]
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.navigation.pages && __props.navigation.pages > 1)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            pages: __props.navigation.pages,
            "onNavigate:next": __props.navigation.nextPage,
            "onNavigate:prev": __props.navigation.prevPage,
            "onNavigate:to": __props.navigation.toPage
          }, null, 8, ["pages", "onNavigate:next", "onNavigate:prev", "onNavigate:to"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "footer")
    ])
  ]))
}
}

})